import React, { useEffect, useState } from "react";
import { ApiConnectionString } from "../../constants/ApiConntection";
import EditProfile from "./EditProfile";
import EditMainProfile from "./EditMainProfile";
import { Dropdown } from "react-bootstrap";
import { Plus, ThreeDotsVertical } from "react-bootstrap-icons";
import ProfilePlaceHolder from "../../assets/ProfilePlaceHolder.png";
import ConfirmDeleteProfile from "./modals/ConfirmDeleteProfile";
import AddProfile from "./AddProfile";
import ProfileLimitReached from "./modals/ProfileLimitReached";
import LoadingSpinner from "../../components/LoadingSpinner";
import axios from "axios";
import { useAuthContext } from "../../hooks/useAuthContext";
import SideMenu from "../../components/SideMenu";
import "./MyProfile.css";
import { useNavigate } from "react-router-dom";

export default function MyProfile() {
  const [editProfile, setEditProfile] = useState(false);
  const [selectedprofile, setSelectedProfile] = useState(null);
  const [editAdditionalProfile, setAdditionalEditProfile] = useState(false);
  const [deleteProfileModal, setDeleteProfileModal] = useState(false);
  const [addProfile, setAddProfile] = useState(false);
  const [profilelimitReachedModal, setProfilelimitReachedModal] =
    useState(false);
  const [profile, setProfile] = useState(null);
  const [profiles, setProfiles] = useState(null);
  const [appUser, setAppUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const { user,dispatch } = useAuthContext();
const navi = useNavigate()

  const goBack = () => {
    setEditProfile(false);
    setAdditionalEditProfile(false);
    setAddProfile(false);
    fetchData();
  };

  const fetchData = async () => {
    try {
      setIsLoading(true);

      const profileResponse = await axios.get(
        `${ApiConnectionString}/api/BookingProfiles?AppUserId=${user.id}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
      const profiles = profileResponse.data;
      setProfile(profiles.filter((profile) => profile.mainProfile === true));
      setProfiles(profiles.filter((profile) => profile.mainProfile != true));

      // Fetch user data
      const userResponse = await axios.get(
        `${ApiConnectionString}/api/user/myprofile`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
      setAppUser(userResponse.data);

      setIsLoading(false);
    } catch (error) {
      if (error.status == 401) {
        dispatch({ type: "LOGOUT" });
        navi("/");
      }
      console.error(error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    let timeout;

    if (user) {
      fetchData();
    } else {
      timeout = setTimeout(() => {
        dispatch({ type: "LOGOUT" });
        navi("/");
        // Add your fallback logic here
      }, 3000); // Delay of 3 seconds before executing the else logic
    }

    return () => clearTimeout(timeout); // Cleanup timeout on re-run
  }, [user]);

  const AddProfileFunc = () => {
    if (profiles.length >= 8) {
      setProfilelimitReachedModal(true);
    } else {
      setAddProfile(true);
    }
  };

  const cancelModal = () => {
    setDeleteProfileModal(false);
    setEditProfile(false);
    setProfilelimitReachedModal(false);
  };

  if (isLoading) {
    return <LoadingSpinner />;
  } else {
    if (addProfile) {
      return <AddProfile fetchData={fetchData} goBack={goBack} />;
    }

    if (editAdditionalProfile) {
      if (profile) {
        return (
          <EditProfile
            id={selectedprofile.id}
            refreshData={fetchData}
            goBack={goBack}
          />
        );
      }
    }

    if (editProfile) {
      if (profile) {
        return <EditMainProfile id={selectedprofile[0].id} goBack={goBack} />;
      }
    } else {
      return (
        <div className="container-fluid mb-5">
          <div className="row">
            <div className="col-3 side-menu-container myProfile-sideMenu">
              <SideMenu />
            </div>

            <div className="col content-container">
              <div className="blueBanner">
<p className="fw-bold p-1 text-center">My Profiles</p>
              </div>
              <div className="d-flex justify-content-center">
                <button
                  onClick={AddProfileFunc}
                  className="profile-blue-button mb-2 d-flex"
                >
                  <Plus className="profile-social-icon" />{" "}
                  <a className="fw-bold mx-2 mt-1">Add Profile</a>
                </button>
              </div>

              <div className="d-flex justify-content-center">
                <div className="bg-white   profileBox rounded shadow position-relative pb-1">
                  <div className="d-flex justify-content-end">
                    <Dropdown>
                      <Dropdown.Toggle
                        as="span"
                        id="dropdown-custom-components"
                        className="dropdown-toggle-custom"
                      >
                        <ThreeDotsVertical
                          style={{ cursor: "pointer" }}
                          onClick={() => setSelectedProfile(profile)}
                          size={25}
                          className="m-2"
                        />
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item onClick={() => setEditProfile(true)}>
                          Edit
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>

                  <div className="main-profile-badge">Main Profile</div>

                  <div className="d-flex justify-content-center">
                    <img
                      src={
                        profile[0].image
                          ? `${ApiConnectionString}/api/profileImage/${profile[0].id}`
                          : ProfilePlaceHolder
                      }
                      alt="Profile Image"
                      width={200}
                      className="m-3 circle-crop"
                    />
                  </div>

                  <div className=" text-center">
                    <p className="red-text  profileUserName">Username</p>
                    <p className="fw-bold profileUserName">
                      {appUser.username}
                    </p>
                  </div>
                  <div className="text-center">
                    <p className="red-text  profileUserName">Name</p>
                    <p className="fw-bold  profileUserName">
                      {appUser.firstName + " " + appUser.lastName}
                    </p>
                  </div>
                  <div className=" ms-auto align-self-start hideMe">
                    <Dropdown>
                      <Dropdown.Toggle
                        as="span"
                        id="dropdown-custom-components"
                        className="dropdown-toggle-custom"
                      >
                        <ThreeDotsVertical
                          style={{ cursor: "pointer" }}
                          onClick={() => setSelectedProfile(profile)}
                          size={25}
                          className="m-2"
                        />
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item onClick={() => setEditProfile(true)}>
                          Edit
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
              </div>

              {profiles.map((addProfile) => (
                <div key={addProfile.id} className="d-flex justify-content-center ">
                  <div className="bg-white   profileBox rounded shadow position-relative pb-1 mt-2">
                  <div className="d-flex justify-content-end " >
                  <Dropdown>
                        <Dropdown.Toggle
                          as="span"
                          id="dropdown-custom-components"
                          className="dropdown-toggle-custom"
                        >
                          <ThreeDotsVertical
                            style={{ cursor: "pointer" }}
                            onClick={() => setSelectedProfile(addProfile)}
                            size={25}
                            className="m-2 showAt800"
                          />
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={() => setAdditionalEditProfile(true)}
                          >
                            Edit
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() => setDeleteProfileModal(true)}
                          >
                            Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                  </div>
                    <div className="d-flex justify-content-center">
                      <img
                        src={
                          addProfile.image
                            ? `${ApiConnectionString}/api/profileImage/${addProfile.id}`
                            : ProfilePlaceHolder
                        }
                        alt="Profile Image"
                        width={200}
                        className=" m-3 circle-crop"
                      />
                    </div>

                    <div className="text-center">
                      <p className="red-text  profileUserName">Username</p>
                      <p className="fw-bold  profileUserName">{addProfile.username}</p>
                    </div>
                    <div className="text-center">
                      <p className="red-text  profileUserName ">Name</p>
                      <p className="fw-bold  profileUserName">
                        {addProfile.firstName + " " + addProfile.lastName}
                      </p>
                    </div>

                    <div className="ms-auto align-self-start hideMe">
                      <Dropdown>
                        <Dropdown.Toggle
                          as="span"
                          id="dropdown-custom-components"
                          className="dropdown-toggle-custom"
                        >
                          <ThreeDotsVertical
                            style={{ cursor: "pointer" }}
                            onClick={() => setSelectedProfile(addProfile)}
                            size={25}
                            className="m-2"
                          />
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={() => setAdditionalEditProfile(true)}
                          >
                            Edit
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() => setDeleteProfileModal(true)}
                          >
                            Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {deleteProfileModal && (
            <ConfirmDeleteProfile
              profile={selectedprofile}
              cancelModal={cancelModal}
              fetchData={fetchData}
            />
          )}
          {profilelimitReachedModal && (
            <ProfileLimitReached cancelModal={cancelModal} />
          )}
        </div>
      );
    }
  }
}
